export default "__VITE_ASSET__DOzDrdC5__"